import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';

import { CtHeader, CtLogin, CtPasswdReset, CtRegister, CtRegisterComplete } from 'containers';
import styled from 'styled-components';

const ScSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
`;
const ScHeader = styled.header`
  height: 60px;
`;
const ScLoginArea = styled.div`
  flex: 1;
  width: 100%;
`;

class LoginPage extends Component {
  render() {
    return (
      <ScSection>
        <ScHeader>
          <Route path="/" component={CtHeader} />
        </ScHeader>
        <ScLoginArea>
          <Route exact path="/login" component={CtLogin} />
          <Route exact path="/login/passwdReset" component={CtPasswdReset} />
          <Route exact path="/register" component={CtRegister} />
          <Route exact path="/register/complete" component={CtRegisterComplete} />
        </ScLoginArea>
      </ScSection>
    );
  }
}

export default withRouter(LoginPage);



// WEBPACK FOOTER //
// ./src/script/pages/LoginPage.js